module.exports = __webpack_public_path__ + "img/private-sale-tamil-table.3c075530.png";